/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $timeout,
  webpage,
  cookies,
  eventService,
  Report,
  uiService,
  reportService,
  reportsService,
  workflowsService,
  labelsService,
  mergeFieldsService,
  REPORT
) => {
  $scope.Model = {
    cookieName: null,
    cookieValue: null,
    availableReports: [],
    availableMergeFields: [],
    availableMilestoneStages: [],
    availableMergeFieldsAdditional: [],
    availableTicketLabels: [],
    currentReport: null,
    currentReportData: {},
    currentFields: [],
    currentHeaders: [],
    ordering: {
      property: 'deal.value',
      isReversed: true
    },
    isDataExportAllowed:
      $rootScope.CurrentAccount.isAdministrator ||
      $rootScope.CurrentOrganization.permissions.usersCanExportData,
    isTicketEditAllowed:
      $rootScope.CurrentAccount.isAdministrator ||
      $rootScope.CurrentOrganization.permissions.usersCanEditDeals,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  reportsService.clearCache();
  $q.all([
    workflowsService.getAvailable({ isActive: true }),
    reportsService.getAvailable({ isActive: true }),
    !$rootScope.IsEnterprise ||
    ($rootScope.IsEnterprise && $rootScope.CurrentOrganization.isBranch)
      ? labelsService.getAvailable({
          type: 'ticket',
          orderBy: 'name',
          coerceTo: 'string',
          isDescending: false,
          isActive: true
        })
      : [],
    mergeFieldsService.getFields(false)
  ])
    .then((data) => {
      // Set Model values
      /* eslint-disable prefer-destructuring */
      $scope.Model.availableMilestoneStages = _.reduce(
        data[0],
        (memo, wf) =>
          memo.concat(
            _.map(
              _.filter(wf.stages, (stage) => stage.isMilestone),
              (stage) => ({
                key: stage.id,
                name: `Workflow - ${wf.name} - ${stage.name}`,
                type: 'string',
                workflow: wf.name,
                fields: [
                  `deal.milestoneStage.${wf.id}.${
                    stage.idClone && stage.idClone !== '' ? stage.idClone : stage.id
                  }.{valueType}`
                ]
              })
            )
          ),
        []
      );
      $scope.Model.availableReports = data[1];
      $scope.Model.availableTicketLabels = _.map(data[2], (l) => ({
        key: l.id,
        name: l.name,
        filters: [{ term: 'idLabels', type: 'string', value: l.id }]
      }));
      $scope.Model.availableMergeFields = data[3];
      $scope.Model.availableMergeFieldsAdditional = []
        .concat(reportService.additionalMergeFields())
        .concat(
          _.flatten(
            _.map($scope.Model.availableMilestoneStages, (s) => [
              {
                name: s.name,
                key: _.first(s.fields).replace('{valueType}', 'sum'),
                type: 'currency'
              },
              {
                name: s.name,
                key: _.first(s.fields).replace('{valueType}', 'count'),
                type: 'number'
              }
            ])
          )
        );
      /* eslint-enable prefer-destructuring */

      // Process state data
      $scope.Model.cookieName = 'stReport';
      $scope.Model.cookieValue =
        cookies.get($scope.Model.cookieName) &&
        cookies.get($scope.Model.cookieName) !== undefined
          ? JSON.parse(cookies.get($scope.Model.cookieName))
          : {};
      if ($scope.Model.cookieValue && $scope.Model.cookieValue.id !== '') {
        $scope.Model.currentReport = _.find(
          $scope.Model.availableReports,
          (report) => report.id === $scope.Model.cookieValue.id
        );
      }
    })
    .then(() => {
      $scope.reportApply($scope.Model.currentReport, 0, 10000);
    });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.reportApply = (report, from, size) => {
    $scope.Model.isReady = false;
    $scope.Model.currentReport = report;

    if (!$scope.Model.currentReport || !$scope.Model.currentReport.id) {
      $scope.Model.currentReport = Report.build(REPORT.DEFAULT);
      cookies.remove($scope.Model.cookieName, { path: '/' });
    } else {
      cookies.set(
        $scope.Model.cookieName,
        JSON.stringify({ id: $scope.Model.currentReport.id }),
        { path: '/' }
      );
    }

    const reportFields = _.uniq($scope.Model.currentReport.fields);
    $scope.Model.currentFields = reportService.simplifyMergeFields(
      reportFields,
      $scope.Model.availableMergeFields,
      $scope.Model.availableMergeFieldsAdditional
    );
    if ($scope.Model.currentReport.quick.isProduct) {
      $scope.Model.currentFields = _.filter(
        $scope.Model.currentFields,
        (obj) =>
          (obj.key && obj.key.indexOf('deal.loan.details.loanSplit') === -1) ||
          (obj.key && obj.key.indexOf('deal.loan.details.loanSplit1') > -1)
      );
    }
    $scope.Model.currentHeaders = _.map($scope.Model.currentFields, 'name');

    const params = {
      report: $scope.Model.currentReport,
      order: {
        field: $scope.Model.ordering.property,
        reversed: $scope.Model.ordering.isReversed
      },
      from,
      size
    };

    reportsService.getWorkflowReport(params).then((reportData) => {
      webpage.pageTitle(`Report ${$scope.Model.currentReport.getName()}`);
      $scope.Model.currentReportData = reportData;
      if (
        $scope.Model.currentReportData &&
        $scope.Model.currentReportData.data &&
        $scope.Model.currentReportData.data.length
      ) {
        $scope.Model.hasSubAggregatedData = reportService.hasNestedAggregation(
          $scope.Model.currentReport
        );
        const orderingField = reportService.orderingField($scope.Model.currentReport);
        if (orderingField) {
          $scope.Model.ordering.property = orderingField;
          $scope.Model.ordering.isReversed =
            orderingField.indexOf('.sum') > -1 || orderingField.indexOf('.count') > -1;
        }
        if (
          !_.isEmpty($scope.Model.currentReportData) &&
          !_.isEmpty($scope.Model.currentReportData.data)
        ) {
          $scope.reportOrder();
        }
      }
      $timeout(() => {
        angular.element('.report .md-virtual-repeat-sizer').css($scope.reportWidth());
        angular.element('.report .md-virtual-repeat-offsetter').css($scope.reportWidth());
      }, 500);
      $scope.Model.isReady = true;
    });
  };

  $scope.exportReport = () => {
    const name = `Report ${$scope.Model.currentReport.getName().trim()}`;
    uiService.toast({
      text: {
        p1: 'Exporting',
        p2: name,
        p3: 'report to Excel'
      },
      progress: true
    });
    reportsService.exportWorkflowReport({
      report: $scope.Model.currentReport,
      order: {
        field: $scope.Model.ordering.property,
        reversed: $scope.Model.ordering.isReversed
      },
      columns: $scope.Model.currentFields,
      name
    });
  };

  $scope.reportOrder = (_property) => {
    if ($scope.Model.ordering.property === _property) {
      $scope.Model.ordering.isReversed = !$scope.Model.ordering.isReversed;
      $scope.Model.currentReportData.data.reverse();
    } else {
      $scope.Model.ordering.property = _property || $scope.Model.ordering.property;
      $scope.Model.ordering.isReversed = _property ? false : $scope.Model.ordering.isReversed;
      $scope.Model.currentReportData.data = _.chain($scope.Model.currentReportData.data)
        .sortNatural($scope.Model.ordering.property)
        .value();
      if ($scope.Model.ordering.isReversed) {
        $scope.Model.currentReportData.data.reverse();
      }
    }
  };

  $scope.zeroValue = (v) => String(v).match(/(^\D{1}0$)|(^0{1}$)|(^0\.00%$)/gm);

  $scope.reportWidth = () => ({
    width: `${$scope.Model.currentHeaders.length * 275}px`
  });

  $scope.reportsOpenSidebar = () => {
    eventService.reportsOpen();
  };
};
